import React from 'react'
import { useState, useEffect } from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper";
import { FaQuoteRight, FaCheck } from "react-icons/fa";
import { Col, Container, Row, Image, Modal, Tab, Tabs } from "react-bootstrap";
import { authServices } from "../../services/auth.services";

function Testemonials() {
    const [show, setShow] = useState(false);
    const [testimonalData, setTestimonalData] = useState([]);
    const [modalData, setModalData] = useState(false);
    const handleShow = (data) => {
        setModalData(data)
        setShow(true)
    };
    const handleClose = () => setShow(false);

    useEffect(() => {
        authServices.getTestimonal().then((resp) => {
            setTestimonalData(resp.data)
        }).catch(err => console.log(err))
    }, [])
    return (
        <>

            <Container className="custm_container">
                <div className="tstmnl_hdng text-center">
                    <h6 className="text_theme">Testimonials</h6>
                    <h2>What Our Client’s Say</h2>
                </div>

                <div className="tstnmnl_wrap">
                    <Swiper
                        spaceBetween={30}
                        slidesPerView={2}
                        loop={true}
                        autoplay={true}
                        pagination={true}
                        // onSlideChange={() => console.log("slide change")}
                        // onSwiper={(swiper) => console.log(swiper)}
                        modules={[Autoplay, Pagination]}
                        className="tstmnl_swiper"
                        breakpoints={{
                            280: {
                                slidesPerView: 1,
                              spaceBetween: 30
                            },
                            676: {
                              slidesPerView: 1,
                              spaceBetween: 30
                            },
                            768: {
                              slidesPerView: 2,
                              spaceBetween: 30
                            },
                          }}
                    >
                        {console.log(testimonalData,"testimonalData")}
                        {testimonalData && testimonalData.map((curr, index, data) => {
                            return (
                                <SwiperSlide
                                >
                                    <div className="tstmnl_slide tstmnl_card">
                                        <div className="clnt_fdback">
                                            <p>
                                                <p dangerouslySetInnerHTML={{ __html: curr?.description.length < 225 ? curr.description : curr?.description.slice(0, 225)+"..." }} />
                                                {
                                                    curr?.description.length > 225&& 
                                                    <p
                                                    className="cmn_link"
                                                    onClick={() => 
                                                        handleShow(curr)}
                                                >
                                                    Continue Reading
                                                </p>
                                                }
                                                
                                            </p>
                                        </div>
                                        <div className="clnt_info d-flex align-items-center position-relative">
                                            <div className="clnt_img">
                                                <Image src={`${process.env.REACT_APP_BASE_URL}admin/getImage?document=${curr?.image}&type=testimonials`} fluid />
                                            </div>
                                            <div className="clnt_nm position-relative">
                                                <h5>{curr?.name} </h5>

                                            </div>
                                            <div className="tst_quot">
                                                <FaQuoteRight />
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            )
                        })}

                    </Swiper>
                </div>
            </Container>

            <Modal
                show={show}
                onHide={handleClose}
                className="main_modl"
                dialogClassName="modal_wdth"
                centered
            >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <div className="tstmnl_slide tstmnl_card">
                        <div className="clnt_fdback">
                            <p dangerouslySetInnerHTML={{__html:modalData?.description}}/>
                        </div>
                        <div className="clnt_info d-flex align-items-center position-relative">
                            <div className="clnt_img">
                                <Image src={`${process.env.REACT_APP_BASE_URL}admin/getImage?document=${modalData?.image}&type=testimonials`} fluid />

                            </div>
                            <div className="clnt_nm position-relative">
                                <h5> {modalData?.name}</h5>
                            </div>
                            <div className="tst_quot">
                                <FaQuoteRight />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>

    )
}

export default Testemonials